<template>
  <nav
    class="navbar navbar-expand-lg navbar-absolute"
    :class="{ 'bg-white': showMenu, 'navbar-transparent': !showMenu }"
  >
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
        <div
          class="navbar-toggle d-inline"
          :class="{ toggled: $sidebar.showSidebar }"
        >
          <button type="button" class="navbar-toggler" @click="toggleSidebar">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <a class="navbar-brand" href="javascript:void(0)"> {{ $route.name }}</a>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        @click="toggleMenu"
        data-toggle="collapse"
        data-target="#navigation"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
      </button>
      <div class="collapse navbar-collapse show text-left" v-show="showMenu">
        <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
          <li class="nav-item d-flex" style="align-items: center">
            {{ nome_usuario ? nome_usuario : nome_empresa }}
          </li>
          <drop-down>
            <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
              <div class="photo">
                <img src="@/assets/img/anime3.png" alt="Profile Photo" />
              </div>
              <b class="caret d-none d-lg-block d-xl-block"></b>
              <p class="d-lg-none">
                Log out
              </p>
            </a>
            <ul class="dropdown-menu dropdown-navbar">
              <li class="nav-link" v-if="controlarSenha()">
                <a
                  href="javascript:void(0)"
                  @click="router('/atualizarSenha')"
                  class="nav-item dropdown-item"
                  >Atualizar Senha</a
                >
              </li>
              <li class="nav-link" v-if="controlarSenha()">
                <a
                  href="javascript:void(0)"
                  @click="router('/atualizarSenhaQuiosque')"
                  class="nav-item dropdown-item"
                  >Atualizar Senha Quiosque</a
                >
              </li>
              <li class="nav-link" v-else>
                <a
                  href="javascript:void(0)"
                  @click="router('/AtualizarSenhaUsuario')"
                  class="nav-item dropdown-item"
                  >Atualizar Senha</a
                >
              </li>
              <li class="nav-link" v-if="controlarMenu('/atualizarEmpresa')">
                <a
                  href="javascript:void(0)"
                  @click="router('/atualizarEmpresa')"
                  class="nav-item dropdown-item"
                  >Atualizar Empresa</a
                >
              </li>
              <li class="nav-link" v-if="controlarMenu('/postosTrabalho')">
                <a
                  href="javascript:void(0)"
                  @click="router('/postosTrabalho')"
                  class="nav-item dropdown-item"
                  >Postos de Trabalho</a
                >
              </li>
              <li class="dropdown-divider"></li>
              <li class="nav-link" @click="logout()">
                <a href="javascript:void(0)" class="nav-item dropdown-item"
                  >Sair</a
                >
              </li>
            </ul>
          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import DropDown from "@/components/Dropdown.vue";
import Modal from "@/components/Modal.vue";
import SidebarToggleButton from "./SidebarToggleButton.vue";

export default {
  components: {
    DropDown,
    Modal,
    SidebarToggleButton,
  },
  props: {
    permissoes: [],
  },
  data() {
    return {
      searchModalVisible: false,
      searchQuery: "",
      showMenu: false,
      nome_empresa: "",
      nome_usuario: "",
    };
  },
  mounted() {
    this.nome_empresa = this.$cookies.get("nome_empresa");
    const dados = this.$cookies.get("usuario");
    if (dados) {
      this.nome_usuario = dados.nome;
    }
  },
  methods: {
    controlarSenha() {
      if (!this.nome_usuario) {
        return true; // admin
      }
      return false;
    },
    controlarMenu(path) {
      if (!this.nome_usuario) {
        return true; // admin
      } else {
        const existe = this.permissoes.find(
          (p) => p.path === path && (p.status === "true" || p.status === true)
        );
        if (existe) {
          return true;
        } else {
          return false;
        }
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    router(param) {
      this.$router.push(param);
    },

    logout() {
      if (confirm("deseja sair?")) {
        this.$cookies.keys().forEach((cookie) => this.$cookies.remove(cookie));
        this.$router.push("/login");
      }
    },
  },
  computed: {
    isRTL() {
      return this.$rtl.isRTL;
    },
  },
};
</script>
<style></style>
